import * as React from "react";

import { cn } from "@/utils/cn";
import { fieldControlClass } from "./field-styles";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, type, ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    data-slot="input"
    className={cn(
      fieldControlClass, "h-9 px-3 py-1",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";

export { Input };
